exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-example { \n\tdisplay: -webkit-box; \n\tdisplay: -ms-flexbox; \n\tdisplay: flex; \n\tpadding: 5px 10px;\n\tmargin-bottom: 5px;\n\tborder: #f4f4f4 solid 1px;\n}\n.grid-example span { \n\tline-height: 24px; \n}\n.grid-example .btn-group { \n\tdisplay: -webkit-box; \n\tdisplay: -ms-flexbox; \n\tdisplay: flex; \n\tmargin-left: auto; \n}\n.grid-example .flow-text { \n\twidth: 100%; \n\tdisplay: -webkit-box; \n\tdisplay: -ms-flexbox; \n\tdisplay: flex; \n\t-webkit-box-align: center; \n\t    -ms-flex-align: center; \n\t        align-items: center; \n\t-webkit-box-pack: end; \n\t    -ms-flex-pack: end; \n\t        justify-content: flex-end; \n\t/* border-bottom: #e4e4e4 solid 1px;  */\n}\n.grid-example .flow-text label { \n\tmargin:6px auto 6px 0; \n}\n.grid-example a { \n\tdisplay: -webkit-box; \n\tdisplay: -ms-flexbox; \n\tdisplay: flex;\n\tpadding: 0 5px;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n}\n.grid-example a i { \n\tfont-size: 18px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-products/add-size/add-size.component.css
// module id = ../../../../../src/app/mnt-products/add-size/add-size.component.css
// module chunks = common